import angular  from 'angular';
import showdown from 'showdown';

/* @ngInject */
export default function ($scope, AuthService, $timeout, LayoutService, $stateParams, toastr, TrainingModules, $state, moment, TrainingAttempts, DocumentsService) {
	$scope.courseId       = $stateParams.courseId;
	$scope.moduleId       = $stateParams.moduleId;
	$scope.loadingModule  = true;
	$scope.loadingAttempt = false;
	$scope.errors         = [];
	$scope.timeStarted    = moment();
	$scope.timeCompleted  = null;

	$scope.parseMarkdown = (markdown) => {
		let converter = new showdown.Converter();

		return converter.makeHtml(markdown);
	};

	$scope.updateViewedAttachments = () => {
		let viewed = true;

		angular.forEach($scope.version.attachments, (attachment) => {
			if (!attachment.viewed) {
				viewed = false;
			}
		});

		$scope.viewedAttachments = viewed;
	};

	$scope.refresh = () => {
		$scope.loadingModule = true;

		TrainingModules.one($scope.moduleId)
		               .get({
			               include: 'course,latestVersion.attachments.document.latestVersion,latestVersion.items',
		               })
		               .then((module) => {
			               $scope.timeStarted = moment();
			               $scope.module      = module;
			               $scope.version     = module.latestVersion;

			               if ($scope.version.attachments && $scope.version.attachments.length > 0) {
				               $scope.version.attachments.sort((a, b) => {
					               return a.sort - b.sort;
				               });
			               }

			               if ($scope.version.items && $scope.version.items.length > 0) {
				               $scope.version.items.sort((a, b) => {
					               return a.sort - b.sort;
				               });
			               }

			               $scope.updateLayout($scope.module.course.name, $scope.module.title, $scope.module.description);

			               angular.forEach($scope.version.attachments, (attachment) => {
				               switch (attachment.type) {
					               case 'video': {
						               attachment.media = {
							               sources: [
								               {
									               src:  DocumentsService.getDownloadURLForDocumentVersionId(attachment.document.latestVersion.id),
									               type: attachment.document.latestVersion.mimeType,
								               },
							               ],
						               };

						               attachment.viewed = false;

						               break;
					               }

					               case 'file': {
						               attachment.source = DocumentsService.getDownloadURLForDocumentVersionId(attachment.document.latestVersion.id);

						               attachment.viewed = true;

						               break;
					               }

					               default: {
						               attachment.viewed = true;

						               break;
					               }
				               }
			               });

			               $scope.updateViewedAttachments();

			               angular.forEach($scope.version.items, (item) => {
				               if (item.type === 'checkbox') {
					               item.chosenAnswer = {};

					               angular.forEach(item.answers, (answer) => {
						               item.chosenAnswer[answer] = false;
					               });
				               } else {
					               item.chosenAnswer = null;
				               }
			               });

			               $scope.loadingModule = false;
		               })
		               .catch((error) => {
			               toastr.clear();
			               toastr.error('There was an error while loading this module, please try again.', 'Error');

			               $state.go('supportWorker.training.view', {
				               courseId: $scope.courseId,
			               });

			               $scope.loadingModule = false;
		               });
	};

	$scope.submit = () => {
		if (!$scope.loadingModule && !$scope.loadingAttempt && $scope.viewedAttachments) {
			$scope.errors = $scope.validate();

			if ($scope.errors.length === 0) {
				$scope.loadingAttempt = true;

				$scope.timeCompleted = moment();

				const attempt = {
					courseId:      $scope.courseId,
					moduleId:      $scope.moduleId,
					versionId:     $scope.version.id,
					timeStarted:   $scope.timeStarted
					                     .format(),
					timeCompleted: $scope.timeCompleted
					                     .format(),
					items:         $scope.version.items.map((item) => {
						let chosenAnswer = [];

						switch (item.type) {
							case 'radio': {
								chosenAnswer.push(item.chosenAnswer);

								break;
							}

							case 'checkbox': {
								angular.forEach(item.chosenAnswer, (selected, value) => {
									if (selected) {
										chosenAnswer.push(value);
									}
								});

								break;
							}

							case 'string': {
								chosenAnswer.push(item.chosenAnswer);

								break;
							}

							case 'textarea': {
								chosenAnswer.push(item.chosenAnswer);

								break;
							}

							case 'comment': {
								if (item.chosenAnswer) {
									chosenAnswer.push(item.chosenAnswer);
								}

								break;
							}
						}

						return {
							itemId:  item.id,
							answers: chosenAnswer,
						};
					}),
				};

				TrainingAttempts.post(attempt)
				                .then((returnedAttempt) => {
					                toastr.clear();
					                toastr.success(`Your answers were submitted successfully, and you scored ${returnedAttempt.achievedMarks} / ${returnedAttempt.potentialMarks}.`);

					                $state.go('supportWorker.training.view', {
						                courseId: $scope.courseId,
					                });
				                })
				                .catch((error) => {
					                toastr.clear();
					                toastr.error('There was an error while submitting your answers, please try again.', 'Error');

					                $scope.loadingAttempt = false;
				                });
			}
		} else {
			if ($scope.loadingModule) {
				toastr.clear();
				toastr.warning('You must wait for the module to load before submitting your answers.');
			} else if ($scope.loadingAttempt) {
				toastr.clear();
				toastr.warning('You must wait for your answers to submit before resubmitting them.');
			} else if (!$scope.viewedAttachments) {
				toastr.clear();
				toastr.warning('You must review all of the attachments (videos, documents) before submitting your answers.');
			}
		}
	};

	$scope.validate = () => {
		let errors = [];

		angular.forEach($scope.version.items, (item) => {
			switch (item.type) {
				case 'radio': {
					if (item.chosenAnswer === null) {
						errors.push(`You must select a value for "${item.label}".`);
					} else if (item.answers.indexOf(item.chosenAnswer) === null) {
						errors.push(`You must select a valid value for "${item.label}".`);
					}

					break;
				}

				case 'checkbox': {
					let selected = false;

					angular.forEach(item.chosenAnswer, (value) => {
						if (value) {
							selected = true;
						}
					});

					if (!selected) {
						errors.push(`You must select at least 1 value for "${item.label}".`);
					}

					break;
				}

				case 'string': {
					if (item.chosenAnswer === null || item.chosenAnswer.trim().length === 0) {
						errors.push(`You must provide an answer for "${item.label}".`);
					}

					break;
				}

				case 'textarea': {
					if (item.chosenAnswer === null || item.chosenAnswer.trim().length === 0) {
						errors.push(`You must provide an answer for "${item.label}".`);
					}

					break;
				}

				case 'comment': {


					break;
				}
			}
		});

		return errors;
	};

	$scope.viewedAttachments = false;

	$scope.$on('vjsVideoReady', (e, data) => {
		$scope.player = data.player;

		$scope.player.on('ended', () => {
			$scope.$apply(() => {
				angular.forEach($scope.version.attachments, (attachment) => {
					if (attachment.type === 'video') {
						if (e.targetScope.vjsCtrl.vjsMedia === attachment.media) {
							attachment.viewed = true;
						}
					}
				});

				$scope.updateViewedAttachments();
			});
		});
	});

	$scope.updateLayout = (courseName = 'Loading...', moduleName = 'Loading...', subtitle = '') => {
		LayoutService.reset();

		LayoutService.setTitle([
			moduleName,
			courseName,
			'Training',
		]);

		LayoutService.getPageHeader()
		             .setSubtitle(subtitle);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'supportWorker.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'supportWorker.training.root',
				             displayName: 'Training',
			             },
			             {
				             route:       `supportWorker.training.view({ courseId: "${$scope.courseId}" })`,
				             displayName: courseName,
			             },
			             {
				             route:       `supportWorker.training.modules.view({ courseId: "${$scope.courseId}", moduleId: "${$scope.moduleId}" })`,
				             displayName: moduleName,
			             },
		             ]);
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/supportWorker/training/modules/view/controller.js